import {
  LOAD_ONBOARDING_STATE,
  UPDATE_ONBOARDING_STATE,
} from './constants';

export function loadOnboardingState() {
  return {
    type: LOAD_ONBOARDING_STATE,
  };
}

export function updateOnboardingState(data) {
  return {
    type: UPDATE_ONBOARDING_STATE,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-onboarding-state/actions.js
 **/